import { CoreIcon } from '../core-icon';
import securityFillSVG from '../../assets/icons/security-fill.svg';
import type { IconProps } from '../core-icon';

export const SecurityFillIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={securityFillSVG} {...props} />;
};
